import gsap from "gsap/gsap-core";

export default class Memory {



    constructor (el) 
    {
        this.el = el
        this.cards = this.el.querySelectorAll('.game__card')
        this.numOpenCards = 0
        this.maxOpenCards = 3

        this.win = {}
    }   
 
    start (win) 
    {
        this.win = win
        for (let card of this.cards) {
            card.removeEventListener('click', this.onClickCardHandler)
        }
        this.shuffle()
    }

    shuffle ()
    {
        gsap.to(this.cards, {
            x: (i, el) => {
                const cWidth = this.el.clientWidth
                const elLeft = el.offsetLeft
                let x = cWidth/2 - elLeft
                if (cWidth < 1200) x = x - el.clientWidth/2
                return x
            },
            y: (i, el) => {
                const cHeight = this.el.clientHeight
                const elTop = el.offsetTop
                let y = cHeight/2 - elTop - el.clientHeight/2
                return y
            },  
            rotation: 180,
            duration: 0.75,
            repeat: 1,
            repeatRefresh: true,
            yoyo: true,
            yoyoEase: true,
            ease: "power3.out",
            onComplete: () => {
                for (let card of this.cards) {
                    card.addEventListener('click', this.onClickCardHandler)
                }
            }
        })            
    }

    onClickCardHandler = (e) => 
    {
        e.preventDefault()

        const card = e.currentTarget

        if (this.numOpenCards < this.win.c) {
            card.classList.add('win')
        }

        card.removeEventListener('click', this.onClickCardHandler)
        card.classList.add('active')

        if (this.numOpenCards === this.win.c) {
            this.endGame(500)
            return
        }

        this.numOpenCards += 1

        if (this.numOpenCards === this.maxOpenCards) {
            this.endGame(150)
            return
        }



    }

    endGame (timeout = 0) 
    {
        for (let card of this.cards) {
            card.removeEventListener('click', this.onClickCardHandler)
        }

        setTimeout(() => {
            this.el.dispatchEvent(new CustomEvent('game.end'))
        }, timeout);
    }
}